// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__3mQu4","modalFooterButton":"ModalNotes_modalFooterButton__3clg7"};